import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  inputsGrid: {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },
  },
  inputGrid: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  dateGrid: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(2),
    },
  },
  buttonGrid: {
    textAlign: "right",
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(1),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  searchButton: {
    float: "right",
    marginRight: 10,
    marginTop: 5,
    [theme.breakpoints.up("md")]: {
      marginRight: 0,
    },
  },
  searchContextSelector: {
    width: "100%",
  },
}));
